<template>
    <div>
        <div class="container__grid">
            <div>
                    <header-page-v4 class="header"></header-page-v4>
                    <!-- banner desafio 1000 -->
                    <div class="banner-v2" v-if="view.propsNewIndex.banner_desafio">
                        <dashboard-banner-v2 :view="banner_info_footer"></dashboard-banner-v2>
                    </div>
                    <earnings-forecast></earnings-forecast>
                    
                    <!-- <affiliate-link-v4 class="affiliate-link"></affiliate-link-v4> -->
                    <!-- <affiliate-link-franchisee-plan-v4 :props="this.view.url_franchisee_plan_info"></affiliate-link-franchisee-plan-v4> -->
                    <!-- <links-user-v4 :props="this.view" v-if="this.view.IS_FRANCHISEE_BA || this.view.dados_usuario_office.id == 10"></links-user-v4> -->
                    <!-- <links-user-v4 :props="this.view" v-if="((this.view.IS_AMBASSADOR || this.view.IS_AMBASSADOR_PLUS) && this.view.dados_usuario_office.subsidiary.id == 2) || (this.view.IS_FRANCHISEE_BA || this.view.dados_usuario_office.id == 10)"></links-user-v4> -->



                    <!-- buttons autoresponder / domain / link generator --> 
                    <ba-franchise-modals-v5 :view="view" />
                    <!-- END buttons autoresponder / domain / link generator --> 

                    <normal-link-user :props="this.view"></normal-link-user>
                    <links-user-v4 :props="this.view" v-if="this.view.IS_AMBASSADOR || this.view.IS_AMBASSADOR_PLUS"></links-user-v4>
                    <!-- <links-user-v4 :props="this.view" v-if="(this.view.IS_AMBASSADOR || this.view.IS_AMBASSADOR_PLUS) && this.isMasterUser"></links-user-v4> -->

                    <!-- //usar estes dois comentados -->
                        <all-values-user-v4 class="all__values" :props="this.view.totais_ganhos"></all-values-user-v4>

                        <!-- <all-values-user-v4 v-if="!this.view.IS_BR" class="all__values" :props="this.view.totais_ganhos"></all-values-user-v4> -->
                        <!-- <all-values-user-br-v4 v-if="this.view.IS_BR" class="all__values" :props="this.view.totais_ganhos"></all-values-user-br-v4> -->
                    <!-- //usar estes dois comentados -->
                    
                    <current-earnings-v4 class="all__values" :props="this.view.totais_ganhos"></current-earnings-v4>
                    <!-- <retention-bonus-v4 v-if="!this.view.IS_BR" class="retention__bonus"></retention-bonus-v4> -->
                    <!--<car-bonus-v4 v-if="!this.view.IS_BR" class="car__bonus"></car-bonus-v4>-->

                    <!-- [17:39] Alexander Held Essa area aqui precisa ser removida completamente da area de afiliados de todos os usuarios -->
                    <!-- <lifestyle-bonus-v5 v-if="!this.view.IS_BR"></lifestyle-bonus-v5> -->

                    <!-- removido a pedido da Thais e concordancia do Ale na data de 14/09/20 -->
                    <!-- <mansion-bonus-v4 v-if="!this.view.IS_BR" class="mansion__bonus"></mansion-bonus-v4> -->

                    <graphic-disclosures-v4 class="graphic__disclosures"></graphic-disclosures-v4>

                    <!-- <affiliates-show-case-v4 class="affiliate__show"></affiliates-show-case-v4> -->
                 <!-- <activate-crm></activate-crm> -->  
                    <div class="btns__rank">
                        <a
                            class="btn__rank"
                            :href="urlLinkRank"
                            v-html="this.view.translation.general.label_click_for_rank_definitions"
                        ></a>
                        <a
                            class="btn__rank"
                            target="_blank"
                            :href="urlLinkCompensationPlan"
                            v-html="this.view.translation.general.label_compensation_plan_details"
                        ></a>
                </div>
            </div>
        </div>
            <div class="resources start__section">
            	<!-- banner template club
                <div class="banner-v2" v-if="view.propsNewIndex.template_club != null">
                    <a target="_blank" :href="view.propsNewIndex.template_club.link">
                        <img style="width: 100%" :src="view.propsNewIndex.template_club.banner">
                    </a>
                </div>
				 -->
                
                <div class="start__title">
                    <h1 v-html="t.start_here_resources_title"></h1>
                </div>
                <div class="start__steps">
                    <div class="step">
                        <div>
                            <span class="order">1</span>
                            <!-- <span class="step_text" v-text="t.label_item"></span> -->
                        </div>
                        <div>
                            <p v-html="t.start_here_bio_label"></p>
                            <textarea 
                                rows="7" 
                                v-model="bioText" 
                                v-bind:maxlength="maxlengthbio">
                            </textarea>
                            <small :style="helperStyleError"> {{ bioTextRemainingChars }} {{ t.label_caracter_restante }}</small>
                            <button
                                :class="[{ __loading: saveBioDisabled}, 'button3 large']"
                                v-text="t.button_salvar" 
                                @click.prevent="updateBio">
                            </button>
                        </div>
                    </div>
                    <div class="step">
                        <div>
                            <span class="order">2</span>
                            <!-- <span class="step_text" v-text="t.label_item"></span> -->
                        </div>
                        <div>
                            <p v-text="t.start_here_gravatar_label"></p>
                            <!-- <small style="font-weight: normal;">Seu gravatar já foi configurado no momento da criação da sua conta. Se você quiser alterá-lo, utilize o botão "SET UP GRAVATAR" acima.</small> -->
                            <div class="gravatar__form">
                                <a 
                                    href="https://en.gravatar.com/connect/" 
                                    target="_blank" 
                                    class="button3 large" 
                                    v-text="t.start_here_setup_gravatar">
                                </a>
                                <div>
                                    <label v-text="t.email"></label>
                                    <input 
                                        type="email" 
                                        readonly="" 
                                        :value="view.dados_usuario_office.email"
                                    >
                                </div>
                                <a class="button3 large" disabled v-text="t.button_salvar" ></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
import qs from "qs";
export default {
    name: "index-v4",
    props: ["view"],
    components: {},
    data() {
        return {
            stepIndex: this.view.dados_usuario_office.franchise_steps,
            showRight: true,
            urlLinkRank: this.view.urls.rota_ranking,
            urlLinkCompensationPlan: this.view.urls.rota_affiliates,
            t: [],
            bioText: '',
            maxlengthbio: 200,
            saveBioDisabled: false,
            helperStyleError: [],
            isMasterUser: false,
            banner_info_footer: {
                banners: {
                    '1920': 'https://office.builderall.com/internacional/public/office4/img/dashboard/banner-v2/br/1920/ic-desafio_elearning-v2.png',
                    '1336': 'https://office.builderall.com/internacional/public/office4/img/dashboard/banner-v2/br/1920/ic-desafio_elearning-v2.png',
                    '1280': 'https://office.builderall.com/internacional/public/office4/img/dashboard/banner-v2/br/1920/ic-desafio_elearning-v2.png',
                    '450': 'https://office.builderall.com/internacional/public/office4/img/dashboard/banner-v2/br/1920/ic-desafio_elearning-v2.png',
                    '300': 'https://office.builderall.com/internacional/public/office4/img/dashboard/banner-v2/br/1920/ic-desafio_elearning-v2.png',
                },
                max_level: true,
                // link: 'https://eb4learning.com/coursenew.php?id=18296&secret=kOmL9tN0keQ7AFZUp5b5'
                link: 'https://office.builderall.com/br/office/empreende/treinamento-top-afiliado'
            }
        };
    },
    mounted() {
        
        this.isMasterUser = this.view.propsNewIndex.is_master_user == 'SIM' ? true : false;
        // console.log('====================================');
        // console.log(this.isMasterUser);
        // console.log('====================================');
        $(document).ready(function() {
            $(".loading").hide();
            $("#app").show();
        });
        
        this.t = this.view.translation;
        this.bioText = this.view.dados_usuario_office.biography == null ? '' : this.view.dados_usuario_office.biography;
    },
    methods: {
        collapseRight(){
            let element = document.querySelector('.container__grid')
            let button = document.querySelector('.collapse__right')
            if (this.showRight) {
                element.style = "grid-template-columns: auto 36px"
                button.style = "transform: rotate(180deg)"
            }
            else{
                element.style = "auto fit-content(250px)"
                button.style = "transform: none"
            }
            this.showRight =! this.showRight
        },
        updateBio: function() {
            if (this.bioText.length > this.maxlengthbio) {
                alertMsg('error','ULTRAPASSOU OS CARACTERES')
            }
            else {
                let vm = this;
                vm.saveBioDisabled = true;
                axios
                .post(
                    vm.view.routes.rota_office_handler_usuarios_complement,
                    qs.stringify({ biography: vm.bioText })
                )
                .then(function(resposta) {
                    alertMsg(resposta.data.status, resposta.data.msg)
                })
                .catch(function(error) {
                    alertMsg('error', 'Network Error');
                })
                .finally(function(){
                    vm.saveBioDisabled = false;
                });
            }
        }
    },

    computed: {
        bioTextRemainingChars: function() {
            if (this.bioText.length > this.maxlengthbio) this.helperStyleError = [{color:'red'}];
            return (this.maxlengthbio - this.bioText.length)
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.affiliate-link {
    display: grid !important;
}
.collapse__right {
    position: absolute;
    top: 100px;
    background: #fff;
    padding: 60px 10px;
    cursor: pointer;
}
.container__grid {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: auto fit-content(250px);
    padding: 0;
}
.btns__rank {
    display: flex;
    flex-wrap: wrap;
    .btn__rank {
        color: white;
        background: var(--theme-color-primary);
        border-radius: 4px;
        margin: 2rem auto 1rem auto;
        display: inline-block;
        padding: 1.1rem 2.5rem;
        transition: 0.1s all ease;
        &:hover {
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        }
    }
}
@media (max-width: 1100px) {
    .container__grid {
        grid-template-columns: auto;
        padding: 2%;
    }
    .collapse__right {
        display: none;
    }
}
@import "../../../../../scss/office";
.start__section {
    margin: .5rem 0;
    .start__title {
        display: flex;
        h1 {
            background: var(--theme-color-primary);
            border-radius: 4px 4px 0px 0px;
            padding: 15px;
            color: #fff;
            flex: 1;
            text-align: center;
            font-size: 1.1rem;
            margin: 0;
            font-weight: bold;
        }
        
    }

    /* INDIVIDUAL CSS SECTIONS = RESOURCES */

    &.resources {
        .start__steps {
            background: #FBFBFB;
            border: 1px solid #DADADA;

            .step {
                display: flex;
                color: #818A91;
                font-weight: bold;
                align-items: center;
                padding: 1rem;
                div {
                    padding: 1rem;

                    .button3 {
                        float: right;
                        margin-top: 6px;
                    }

                    &:first-child {
                        width: 100px;
                        display: flex;
                        flex-direction: column;
                        text-align: center;
                        @media handheld, only screen and (max-width: 768px) {
                            width: auto;
                        }
                        span.order {
                            font-size: var(--theme-color-primary);
                            color: var(--theme-color-primary);
                        }
                        span.step_text {
                            margin-top: 2px;
                            font-size: .95rem;
                            text-transform: uppercase;
                        }
                    }
                    &:last-child {
                        flex: 1;
                        textarea {
                            width: 100%;
                            border: none;
                            background: rgba(196, 196, 196, 0.2);
                            border-radius: 4px;
                            margin: 0.5rem 0;
                            padding: 10px;
                            line-height: 1.2rem;
                        }
                        p {
                            margin: 0 0 10px;
                            font-size: .95rem;
                            line-height: 1.2rem;
                        }
                        .gravatar__form {
                            display: grid;
                            grid-template-columns: auto 1fr auto;
                            align-items: end;
                            padding: 1rem 0;
                            row-gap: 10px;

                            @media handheld, only screen and (max-width: 992px) {
                                grid-template-columns: auto;
                            }


                            div {
                                padding: 0 1rem;
                                label {
                                    font-size: 10pt;
                                }
                                input {
                                    display: block;
                                    padding: 10px;
                                    border: none;
                                    width: 100%;
                                }
                            }
                        }
                    }
                }
                &:nth-child(even) {
                    background: rgba(196, 196, 196, 0.2);
                }
            }
        }
    }

    /* INDIVIDUAL CSS SECTIONS = IMPORTANT TRTAINNING */
    /*
    &.important__trainning {
        .start__steps {
            .trainning__container {
                width: 80%;
                max-width: 765px;
                margin: 0.5rem auto;
                display: grid;
                gap: .5rem;
                grid-template-areas:
                    "grid__welcome grid__resources"
                    "grid__sales grid__resources"
                ;
                @media handheld, only screen and (max-width: 768px) {
                    grid-template-areas:
                        "grid__welcome"
                        "grid__sales"
                        "grid__resources"
                    ;
                }

                div.grid__area {
                    padding: 1.3rem;
                    background: #FFFFFF;
                    border: 1px solid #E5E5E5;
                    border-radius: 4px;
                    &.grid__welcome {
                        grid-area: grid__welcome;
                        li:before {
                            content: "\2022 1."counters(item, ".") " ";
                        }
                    }
                    &.grid__sales {
                        grid-area: grid__sales;
                        li:before {
                            content: "\2022 2."counters(item, ".") " ";
                        }
                    }
                    &.grid__resources {
                        grid-area: grid__resources;
                        li:before {
                            content: counters(item, ".") ". ";
                        }
                    }
                    div {
                        display: flex;
                        align-items: center;
                        h3 {
                            margin: 0;
                            padding: 0.7rem;
                            font-size: 1.3rem;
                        }
                        span.order {
                            font-size: 2.4rem;
                            color: var(--theme-color-primary);
                            font-weight: bolder;
                            padding: 0 1rem;
                        }
                    }
                    ol {
                        padding: 0 1rem;
                        counter-reset: item;
                        li {
                            list-style-position: inside;
                            color: #5B5B5B;
                            margin: 1.5rem 0px;
                            display: block;
                            &:before {
                                counter-increment: item;
                            }
                        }
                    }
                    hr {
                        width: 70%;
                        margin: 10px 0 20px 14px;
                        border-top-width: 2px;
                    }
                }
                
            }
        }
    }
    */
}


.button3 {
    font-weight: bold;
    text-transform: uppercase;
}
@media (max-width: 750px) {
    .start__section.resources .btn__header {
        width: 100% !important;
    }
}
.banner-v2 {
    margin-bottom: 1.5rem;
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/index/index.vue